import * as React from 'react';
import AddBenefitCategoryBtn from './AddBenefitCategoryBtn';
import { useGetAllBenefitQuery } from '@/store/benefitApi';
import { useSelector } from 'react-redux';
import { RootState } from '@/types';
import BenefitFormDialog from './BenefitFormDialog';
import useSearchBenefit from '@/hooks/useSearchBenefit';
import RecentBenefits from './RecentBenefits';
import { useParams } from 'react-router-dom';
import { useGetBenefitCategoryQuery } from '@/store/benefitCategoryApi';
import BenefitFilterSection from './BenefitFilterSection';

const BenefitPage = () => {
  const { user } = useSelector((state: RootState) => state.user);
  const { data: allBenefits } = useGetAllBenefitQuery(user?.token);
  const [searchTerm, setSearchTerm] = React.useState('');
  const [filteredBenefits] = React.useState('');
  const [isOpen, setIsOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);
  const { data: allLedger } = useGetBenefitCategoryQuery(user?.token);

  // Fetch category (ledger.ledger) from the URL params
  const { category } = useParams();

  // Filter benefits based on the 'ledger.ledger' field
  const filteredByLedgerName = allBenefits?.filter(
    (benefit) => benefit.ledger?.ledger === category
  ) || [];

  // Use the search hook with the filtered benefits
  const { filterBySearchTerm } = useSearchBenefit(
    filteredByLedgerName,
    searchTerm,
    filteredBenefits
  );

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-8">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
          <h1 className="text-2xl font-bold text-foreground mb-4 sm:mb-0">
            Benefits Category View
          </h1>

          <div className="border-2 border-emerald-600 px-3 py-1 rounded-md bg-emerald-50 dark:bg-emerald-950">
            <h1 className="text-md font-bold text-emerald-600 mb-4 sm:mb-0">
              {category?.toUpperCase()}
            </h1>
          </div>

          <div className="flex flex-wrap gap-3">
            <AddBenefitCategoryBtn />
            <BenefitFormDialog
              open={isOpen}
              setOpen={setIsOpen}
              editBenefit={editData}
              setEdit={setEditData}
            />
          </div>
        </div>

        {/* Filter Section */}
        <BenefitFilterSection
          filterBySearchTerm={filterBySearchTerm}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      </div>

      {/* Render filtered transactions */}
      <RecentBenefits
        filterBySearchTerm={filterBySearchTerm}
        setEditData={setEditData}
        setIsOpen={setIsOpen}
      />
    </div>
  );
};

export default BenefitPage;
